import useUpdateUser, { loginUserInfo } from '@/common/recoil/atom/userAtom'
import { useJumpLogin } from '@/pages/login/utils'
import { DropMenu } from '@roo/roo'
import React, { useEffect } from 'react'
import { logout } from '@/common/api/api'
import { useRecoilValue } from 'recoil'
import styles from './index.module.less'
import { useTranslation } from '@sailor/i18n-web'
import { useNavigate } from 'react-router'

const LoginUserInfo = () => {
  const jumpLogin = useJumpLogin()
  const userInfo = useRecoilValue(loginUserInfo)
  const { t } = useTranslation()
  const navigate = useNavigate()

  const updateUserInfo = useUpdateUser()

  function handleLogout () {
    logout().catch(() => {})
    updateUserInfo('delete') // 清除登录信息
    jumpLogin() // 跳转登录
  }


  useEffect(() => {
    if (!userInfo?.entName) {
      updateUserInfo()
    }
  }, [userInfo?.entName]) // 初始化用户信息

  const menu = [
    userInfo?.adminInfo && {
      key: 'logout',
      label: t('e_pc_logout', '退出登录'),
      onClick: handleLogout,
    },
    userInfo?.adminInfo?.email &&
    {
      key: 'modifyPassword',
      label: t('e_pc_modify_password', '修改密码'),
      onClick: () => navigate('/password/reset'),
    },
  ].filter(item => item)

  return (
    (
      <div className={styles.logininfo} style={{ width: '256px' }}>
        <DropMenu
          trigger="hover"
          menu={menu}
          popupClassName="ex-pop"
          style={{ textAlign: 'center', alignItems: 'center', width: '100%' }}
          placement="bottomLeft"
        >
          {userInfo?.entName} {userInfo?.entAdminName ? '|' :  ''} {userInfo?.entAdminName || t('e_pc_logout', '退出登录')}
        </DropMenu>
      </div>
    )
  )
}
export default LoginUserInfo